import * as z from "zod";
import {DEFAULT_MANAGER_INFORMATION, ManagerInformationModel} from "./ManagerInformationModel";

const schema = z.object({
	id: z.string().nullable(),
	manualUpdateDate: z.string().nullable(),
	name: z.string().nullable(),
	belongTo: z.string().nullable(),
	telephone: z.string().nullable(),
	jibunAddress: z.string().nullable(),
	managerInformation: ManagerInformationModel.model.nullable().default(DEFAULT_MANAGER_INFORMATION),
	etc: z.string().nullable()
});

const model = schema.transform((values) => ({
	...values
}));

export const BelongToTaxAccountantResModel = {schema, model};
export type IBelongToTaxAccountantResModel = z.infer<typeof BelongToTaxAccountantResModel.model>;
export const DEFAULT_BELONG_TO_TAX_ACCOUNTANT_RES: IBelongToTaxAccountantResModel = {
	id: null,
	manualUpdateDate: "",
	name: "",
	belongTo: "",
	telephone: "",
	jibunAddress: "",
	managerInformation: DEFAULT_MANAGER_INFORMATION,
	etc: ""
};
